import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Star = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M7.10557 2.11187C7.4741 1.37482 8.5259 1.37482 8.89443 2.11187L10.4913 5.30564L13.6392 5.69912C14.4238 5.7972 14.7896 6.72413 14.2833 7.33159L12.2807 9.73477L12.6947 13.4605C12.7822 14.2482 11.9624 14.8198 11.2536 14.4654L8 12.8386L4.74643 14.4654C4.03759 14.8198 3.21782 14.2482 3.30533 13.4605L3.71931 9.73477L1.71665 7.33159C1.21043 6.72412 1.57621 5.7972 2.36084 5.69912L5.50869 5.30564L7.10557 2.11187ZM8 3.67712L6.49131 6.69449L3.45462 7.07407L5.28069 9.26536L4.89765 12.7127L8 11.1615L11.1023 12.7127L10.7193 9.26536L12.5454 7.07407L9.50869 6.69449L8 3.67712Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Star;
